import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n        Re-assign Approvers\n      ")
], -1);
const _hoisted_3 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_4 = { class: "bg-white p-8 shadow overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { class: "border-t border-gray-200 px-4 py-5 sm:p-0" };
const _hoisted_6 = { class: "my-4" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_8 = { class: "my-4 flex" };
const _hoisted_9 = {
    key: 0,
    class: "w-full"
};
const _hoisted_10 = {
    key: 1,
    class: "w-full"
};
const _hoisted_11 = { class: "flex" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", {
    for: "userId",
    class: "block text-sm font-medium text-gray-700"
}, "User ID:", -1);
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "ml-4" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "flex justify-end" };
const _hoisted_17 = ["disabled"];
import { XIcon } from '@heroicons/vue/outline';
import { computed, inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import UserSearch from '@/components/userDropdownSearch.vue';
import httpClient from '@/httpClient';
import { saveStorage } from '@/storageSave';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReAssign',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const formData = ref({});
        const stages = inject('stages', []);
        const selectedType = ref('HM');
        const selectedUser = ref('');
        const types = [
            {
                text: 'Hiring manager',
                value: 'HM',
                group: 'HM',
            },
            {
                text: 'Secondary contact',
                value: 'CONTACT',
                group: 'ALL',
            },
            {
                text: 'First line approver',
                value: 'FIRST',
                group: 'HM',
            },
            {
                text: 'Second line approver',
                value: 'SECOND',
                group: 'HROPS',
            },
            {
                text: 'Admin owner',
                value: 'ADMIN',
                group: 'H2R',
            },
            {
                text: 'Resourcing Owner',
                value: 'RESOURCING',
                group: 'RESOURCING',
            },
        ];
        const currentStage = computed(() => stages.find((stage) => stage.stageName === formData.value.currentStageName));
        const currentType = computed(() => types.find((type) => type.value === selectedType.value));
        const docId = computed(() => router.currentRoute.value.params.id);
        const docOwner = computed(() => router.currentRoute.value.params.docOwner);
        const handleUser = (event) => {
            selectedUser.value = event.userID;
        };
        const handleCancelUser = () => {
            selectedUser.value = '';
        };
        const fetchSingleAtr = async () => {
            store.dispatch('setIsLoading', true);
            const payload = {
                requestedBy: docOwner.value,
                id: docId.value,
            };
            const response = await httpClient.post('/bff/get-document', payload);
            const body = response.data.body;
            const item = body?.Item ?? {};
            formData.value = item;
            saveStorage('formData', JSON.stringify(item));
            if (item.shortId) {
                saveStorage('atrShortId', item.shortId);
            }
            if (item.docId) {
                saveStorage('atrId', item.docId);
            }
            store.dispatch('setIsLoading', false);
        };
        const handleReassign = async () => {
            const payload = {
                requestedBy: docOwner.value,
                id: docId.value,
                selectedType: selectedType.value,
                selectedUser: selectedUser.value,
            };
            try {
                await httpClient.post('/bff/reassign-request', payload);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: 'This approver has been updated',
                });
                router.go(-1);
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'Could not update the approver',
                });
            }
        };
        onMounted(async () => await fetchSingleAtr());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createTextVNode("\n            Document: " + _toDisplayString(formData.value?.docId), 1),
                                _hoisted_7,
                                _createTextVNode("\n            Current Stage: " + _toDisplayString(currentStage.value?.displayName), 1)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_8, [
                                (!selectedUser.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createVNode(UserSearch, {
                                            group: currentType.value.group,
                                            onUpdatedUser: handleUser
                                        }, null, 8, ["group"])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _hoisted_12,
                                            _createTextVNode(),
                                            _createElementVNode("input", {
                                                value: selectedUser.value,
                                                type: "text",
                                                name: "userId",
                                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200",
                                                disabled: ""
                                            }, null, 8, _hoisted_13),
                                            _createTextVNode(),
                                            _createElementVNode("button", {
                                                class: "ml-2",
                                                onClick: _withModifiers(handleCancelUser, ["prevent"])
                                            }, [
                                                _createVNode(_unref(XIcon), { class: "w-5 h-5 text-gray-400 hover:text-gray-800" })
                                            ])
                                        ])
                                    ])),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_14, [
                                    _withDirectives(_createElementVNode("select", {
                                        id: "type-select",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedType).value = $event)),
                                        name: "type",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                                    }, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(types, (t) => {
                                            return _createElementVNode("option", {
                                                key: t.value,
                                                value: t.value
                                            }, _toDisplayString(t.text), 9, _hoisted_15);
                                        }), 64))
                                    ], 512), [
                                        [_vModelSelect, selectedType.value]
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                                class: "text-center px-4 py-2 rounded-md text-white bg-green-700 hover:underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 bg-no-repeat disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed",
                                disabled: !selectedUser.value,
                                onClick: _withModifiers(handleReassign, ["prevent"])
                            }, "Confirm Re-assignment", 8, _hoisted_17)
                        ])
                    ])
                ])
            ]));
        };
    }
});
